import type { FC } from "react";
import { useTranslation } from "react-i18next";
import { Loader } from "lucide-react";
import { Button } from "@ui/Button";
import { useMultiStepForm } from "@/hooks";

interface SummaryStepButtonsProps {
  onCancel: () => void;
  onSave: () => void;
  dataTest?: string;
}

const SummaryStepButtons: FC<SummaryStepButtonsProps> = ({ onCancel, onSave, dataTest = "" }) => {
  const { t } = useTranslation();
  const { isLoading } = useMultiStepForm();

  return (
    <div className="flex flex-row gap-4 sm:justify-end">
      <Button
        variant="secondary"
        className="flex-1 uppercase sm:flex-none"
        onClick={onCancel}
        data-test={`${dataTest}-cancel`}
      >
        {t("cancel")}
      </Button>
      <Button
        className="w-full flex-1 uppercase sm:w-[109px] sm:flex-none"
        onClick={onSave}
        data-test={`${dataTest}-save`}
        disabled={isLoading}
      >
        {isLoading ? <Loader className="animate-spin" /> : t("save")}
      </Button>
    </div>
  );
};

export default SummaryStepButtons;
